import Flickity from 'flickity-imagesloaded';
import enquire from 'enquire.js';

const prevBtn = document.querySelector('.sub-nav__btn--prev');
const nextBtn = document.querySelector('.sub-nav__btn--next');
const wrapper = document.querySelector('.sub-nav__wrap');

const toggleButtons = (flkty) => {
    const slides = flkty.slides;
    const lastIndex = slides.length ? slides.length - 1 : 0;

    if (flkty.selectedIndex === 0) {
        prevBtn.classList.add('disabled');
        wrapper.classList.add('prev-disabled');
    } else {
        prevBtn.classList.remove('disabled');
        wrapper.classList.remove('prev-disabled');
    }

    if (flkty.selectedIndex === lastIndex) {
        nextBtn.classList.add('disabled');
        wrapper.classList.add('next-disabled');
    } else {
        nextBtn.classList.remove('disabled');
        wrapper.classList.remove('next-disabled');
    }
};

const setupFlickity = (carousel) => {
    const flkty = new Flickity(carousel, {
        prevNextButtons: false,
        pageDots: false,
        cellAlign: 'left',
        groupCells: '100%',
        contain: true,
        setGallerySize: false,
        on: {
            ready() {
                this.selectCell('.sub-nav__item.active');
                toggleButtons(this);
            },
        },
    });

    prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        flkty.previous();
    });

    nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        flkty.next();
    });

    flkty.on('select', () => {
        toggleButtons(flkty);
    });

    return flkty;
};


export default(() => {
    const carousel = document.querySelector('.js-sub-nav');
    const isAccount = document.querySelector('.account');

    if (carousel) {
        let flkty;
        enquire.register(`screen and (min-width: ${isAccount ? 700 : 768}px)`, {
            match() {
                flkty = setupFlickity(carousel);
            },
            unmatch() {
                if (typeof flkty === 'object') {
                    flkty.destroy();
                }
            },
        });
    }
})();
